import React from 'react'
import { ErrorBoundary } from '@wix/external-component-renderer'

export interface ExternalComponentProps {
	compProps?: any
}

export const prepareTrustedComponent = (Comp: React.ComponentType, onError: (error: Error) => void) => ({
	compProps,
}: ExternalComponentProps) => {
	return (
		<ErrorBoundary onError={onError}>
			<Comp {...compProps} />
		</ErrorBoundary>
	)
}
